//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import arrowOrange from '@/assets/imgs/arrow-orange.svg';
import footerAbstract from '@/assets/imgs/blog-footer-abstract.svg';
import smallAbstract0 from '@/assets/imgs/small-abstract-1.svg';
import smallAbstract1 from '@/assets/imgs/small-abstract-2.svg';
import smallAbstract2 from '@/assets/imgs/small-abstract-3.svg';
import smallAbstract3 from '@/assets/imgs/small-abstract-4.svg';
import smallAbstract4 from '@/assets/imgs/small-abstract-5.svg';
import smallAbstract5 from '@/assets/imgs/small-abstract-6.svg';
import { page } from '@/mixins/wp-post';

export default {
  name: 'KnockServices',

  mixins: [page('services')],

  data() {
    return {
      activeIndex: 0,
      smallAbstract0,
      smallAbstract1,
      smallAbstract3,
      smallAbstract4,
      smallAbstract5,
      arrowOrange,
      footerAbstract,
      smallAbstract: [smallAbstract0, smallAbstract1, smallAbstract2, smallAbstract3, smallAbstract4, smallAbstract5]
    };
  },

  computed: {
    active() {
      return this.page.acf.services[this.activeIndex];
    }
  },

  mounted() {
    if (this.$route.hash) {
      const hash = this.$route.hash.substring(1);

      this.page.acf.services.forEach((service, index) => {
        if (hash === service.name.toLowerCase()) {
          this.activeIndex = index;
        }
      });
    }
  },

  methods: {
    switchActive(index) {
      this.activeIndex = index;
    },
    start(el) {
      el.style.height = `${el.scrollHeight}px`;
    },
    end(el) {
      el.style.height = '';
    }
  }

};
